import { render } from "./401.vue?vue&type=template&id=41a2c0d0&scoped=true"
const script = {}

import "./401.vue?vue&type=style&index=0&id=41a2c0d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\LoesusOFSite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a2c0d0"]])

export default __exports__